import { FormFieldType } from '@/types/enums'

/** Longer text than this reads better across the whole row than squeezed into half of it. */
const LONG_TEXT = 60
/** Choice lists longer than this get the whole row. */
const MANY_CHOICES = 4

/**
 * Whether a record field takes the whole row of the record page's two-column bento grid: long
 * choice lists and long text. Everything else shares a row, and
 * cells keep their own height, so one tall field never stretches its neighbour.
 */
export function isWideField(
  type: string,
  value: string | null | undefined,
  options: Record<string, unknown> | null | undefined
): boolean {
  if (type === FormFieldType.CHECKBOX || type === FormFieldType.RADIO) {
    const choices = (options?.choices ?? options?.values) as unknown[] | undefined
    return (choices?.length ?? 0) > MANY_CHOICES
  }
  if (type === FormFieldType.TEXT || type === FormFieldType.EMAIL || type === FormFieldType.URL) {
    return (value?.length ?? 0) > LONG_TEXT
  }
  return false
}
